import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { HorizontalTabsComponent } from "../../../../horizontal-tabs/horizontal-tabs.component";
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from "@angular/material/expansion";
import { MatIcon } from "@angular/material/icon";
import { NgIf } from "@angular/common";
import { SvgIconComponent } from "../../../../svg-icon/svg-icon.component";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { Router } from "@angular/router";
import { FinanceApiService } from "../../../../../services/finance-a-p-iervice.service";
import { TableListRequest } from "../../../../../models/table-list-request.interface";
import { style } from "@angular/animations";
import { NoDataComponent } from "../../../../no-data/no-data.component";
import { LoadingService } from "../../../../../services/loading.service";
import { ToasterService } from "../../../../../services/toaster.service";
import { IrnGenErrorComponent } from "../../irn-gen-error/irn-gen-error.component";
import { DateUtils } from "../../../../../utils/date-utils";
import { SkeletonLoaderComponent } from "../../../../skeleton-loader/skeleton-loader.component";
import { SpinnerLoaderComponent } from "../../../../spinner-loader/spinner-loader.component";

const TABS = {
  PAYMENT: "payment",
  CREDIT_NOTE: "creditNote"
};

@Component({
  selector: "app-manage-invoice-details",
  standalone: true,
  imports: [
    HorizontalTabsComponent,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatIcon,
    NgIf,
    SvgIconComponent,
    PdfViewerModule,
    IrnGenErrorComponent,
    NoDataComponent,
    SkeletonLoaderComponent,
    SpinnerLoaderComponent,
    SpinnerLoaderComponent
  ],
  templateUrl: "./manage-invoice-details.component.html",
  styleUrl: "./manage-invoice-details.component.scss"
})

export class ManageInvoiceDetailsComponent {
  tabs: any[] = [{ id: TABS.PAYMENT, label: "Payment Received" }, { id: TABS.CREDIT_NOTE, label: "Credit Note" }];
  selectedTab: string | undefined = "";
  creditNoteData: any[] = [];
  paymentReceivedData: any[] = [];
  pdfSrc!: string;
  isLoading: boolean = false;

  @Input() invoiceRecord: any = {};

  @Output() actionClicked = new EventEmitter<{ actionName: string, record: any }>();

  constructor(private router: Router,
              private financeApiService: FinanceApiService,
              private loadingService: LoadingService,
              private toasterService: ToasterService) {

  }

  ngOnInit() {
    // this.getCreditNoteTableData();

    if (this.invoiceRecord.status !== "PENDING") {
      this.getInvoicePdf();
    }

    this.loadingService.loading$.subscribe({
      next: data => {
        if (data.isLoading && data.type === 'inline') {
          this.isLoading = data.isLoading;
        }else{
          this.isLoading = false;
        }
      },
      error: err => {
        this.isLoading = false;
      }
    })
  }

  ngOnDestroy() {
    // this.financeApiService.clearInvoicePdfSource();
  }

  @ViewChild("expansionPanel") expansionPanel: MatExpansionPanel | undefined;

  changeSelectedTabAndToggleAccordion(tabId?: string) {
    if (this.selectedTab === tabId) {
      this.selectedTab = "";
      this.expansionPanel?.close();
    } else {
      this.selectedTab = tabId;
      if (this.selectedTab === TABS.CREDIT_NOTE) {
        this.getCreditNoteTableData();
      } else if (this.selectedTab === TABS.PAYMENT) {
        this.getPaymentsTableData();
      }
      this.expansionPanel?.open();
    }
  }

  toggleAccordion() {
    // this.expansionPanel?.toggle();
    if (this.expansionPanel?.expanded) {
      this.expansionPanel.close();
      this.selectedTab = "";
    } else {
      this.expansionPanel?.open();
      this.selectedTab = this.tabs[0].id;
      this.getPaymentsTableData();
    }
  }

  onActionClick(action: string) {
    this.actionClicked.emit({ actionName: action, record: this.invoiceRecord });
  }

  private getCreditNoteTableData() {
    this.loadingService.show('inline');
    const tableListRequest: TableListRequest = {
      limit: 10,
      page: 0,
      where: {
        filterConditions: [
          {
            name: "INVOICE_ID_EQUALS",
            alias: "INVOICE_ID_EQUALS",
            value: [this.invoiceRecord.id]
          }
        ],
        expression: "INVOICE_ID_EQUALS"
      }
    };
    this.financeApiService.listCreditNotes(tableListRequest).subscribe({
      next: (res: any) => {
        this.creditNoteData = res.data?.records;
        this.loadingService.hide();
      },
      error: (err) => {
        this.loadingService.hide();
        this.toasterService.error(err.error.message);
      }
    });
  }

  private getInvoicePdf() {
    this.loadingService.show('inline');
    this.financeApiService.getInvoicePdf(this.invoiceRecord.id).subscribe({
      next: (res: any) => {
        this.pdfSrc = `data:application/pdf;base64,${res.data}`;
        // this.financeApiService.setInvoicePdfSource(res.data);
        this.loadingService.hide();
      },
      error: (err: any) => {
        this.loadingService.hide();
        this.toasterService.error(err.error.message);
      }
    });
  }

  private getPaymentsTableData() {
    this.loadingService.show('inline');
    this.financeApiService.getPaymentsForInvoice(this.invoiceRecord.id).subscribe({
      next: (res: any) => {
        this.paymentReceivedData = res.data;
        this.loadingService.hide();
      },
      error: (err) => {
        this.loadingService.hide();
        this.toasterService.error(err.error.message);
      }
    });
  }

  protected readonly TABS = TABS;
  protected readonly DateUtils = DateUtils;
  protected readonly style = style;
}
